import {styled} from '@mui/material/styles';

export default function TH() {
    return (
        <Agreement>
            <h1>📄 Investor Agreement</h1>
            <p>IGE RWA Supply Chain Finance Investment Agreement<br/>
            Version Number: IGE-RWA-2025V1.0<br/>
            Effective Date: The signature becomes effective once it is recorded on-chain.</p>
            
            <p>Please read this agreement carefully. By checking the “Agree and Continue” option, it is deemed that you have read, understood, and accepted all the contents of this agreement and agree to comply with the relevant provisions.</p>

            <ul>
                <li><strong>Parties to the Agreement</strong><br/>
                This agreement is jointly signed by IGE International Gold Exchange Limited (hereinafter referred to as the “Platform” or “IGE”) and the users who register and use the IGE RWA investment model (hereinafter referred to as the “Investor” or “You”).</li>

                <li><strong>Business Overview</strong><br/>
                2.1 IGE utilizes RWA (Real World Asset on-chain) technology to digitize bulk gold trading, allowing ordinary investors to participate in the global gold market and achieve low-threshold investment.<br/>
                2.2 You can invest in gold assets through the platform and earn returns in accordance with platform regulations.<br/>
                2.3 Your investment principal will be used in gold trading business, and the profit comes from price spread in the gold trading market.</li>

                <li><strong>Investment Rules</strong><br/>
                3.1 Minimum investment amount: No fixed threshold, users can invest freely based on their own needs.<br/>
                3.2 Investment period: 7 days (starts counting after the asset package is full)<br/>
                3.3 Rate of return: Standard is 1.2% / 7 days, calculated based on investment amount and returned to the account after the period ends.<br/>
                3.4 Distribution of returns: After the investment period ends, users can choose to withdraw or reinvest.<br/>
                3.5 Early exit: Not allowed during the investment period, must be held until maturity.<br/>
                3.6 If the asset package is not fully funded within 48 hours, the invested funds will be fully refunded to the investor’s account.</li>

                <li><strong>Fund Management</strong><br/>
                4.1 Capital safety guarantee: Your funds are used for physical gold trading and are supervised by banks, insurance companies, and third-party institutions throughout the process.<br/>
                4.2 Withdrawal rules: Withdrawals must follow platform procedures and usually arrive on-chain within 1–2 minutes.<br/>
                4.3 Service fee: The platform charges a 5‰ handling fee.</li>

                <li><strong>Risk Warning</strong><br/>
                5.1 Liquidity risk: Investment must be held to maturity and cannot be redeemed early. Please arrange funds reasonably.<br/>
                5.2 Force majeure: IGE is not responsible for losses caused by force majeure events such as war, government policy adjustments, or system failures.</li>

                <li><strong>Rights and Obligations of Users</strong><br/>
                6.1 Your Rights<br/>
                 • Right to inquire about investment returns, withdrawals, reinvestment, and related information.<br/>
                 • Right to invest freely within the scope stipulated by the platform and obtain corresponding returns.<br/>
                6.2 Your Obligations<br/>
                 • Ensure that the personal information provided is true and valid. Do not use someone else's identity to register or invest.<br/>
                 • Abide by relevant national laws and regulations as well as platform rules. Do not use the platform for illegal activities.</li>

                <li><strong>Rights and Obligations of IGE</strong><br/>
                7.1 The platform commits to strictly managing investment funds and ensuring compliance and transparency in gold trading.<br/>
                7.2 The platform has the right to suspend or terminate user accounts in case of violations.</li>

                <li><strong>Governing Law and Dispute Resolution</strong><br/>
                8.1 This agreement is governed by the laws of the place where the platform operates (such as Thailand or the place where IGE headquarters is located).<br/>
                8.2 In case of disputes, both parties shall resolve through friendly negotiation. If negotiation fails, the dispute shall be submitted to the local court for a ruling.</li>

                <li><strong>Other Terms</strong><br/>
                9.1 IGE reserves the final right of interpretation of this agreement.<br/>
                9.2 IGE has the right to update the contents of this agreement based on market conditions. The modified agreement will be announced on the platform, and users must reread and agree before continuing to invest.<br/>
                9.3 IGE does not provide investment services to users in regions where USDT is not legally recognized.</li>
            </ul>
          <p>Please confirm that you have read and understood this agreement. If you have no objection, Please click "Agree" to continue investing.</p>
        </Agreement>

    )
}

const Agreement = styled('div')`
    font-family: "Noto Sans TC", sans-serif;
    line-height: 1.6;
    padding: 20px;
    color: #eaeaea;
    & h1, & h2 {
        text-align: center;
        margin-bottom: 10px;
    }
    & h3 {
        margin-top: 20px;
        font-weight: bold;
        color: #b3b3b3;
    }

    ul {
        margin-left: 0px;
    }
`